import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CurrenciesRoutes: Routes = [
  {
    path: "currencies",
    loadComponent: () =>
      import("./currencies.component").then((m) => m.CurrenciesComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./currencies-list/currencies-list.component").then(
            (m) => m.CurrenciesListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./currencies-form/currencies-form.component").then(
            (m) => m.CurrenciesFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./currencies-form/currencies-form.component").then(
            (m) => m.CurrenciesFormComponent,
          ),
      },
    ],
  },
];
